import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32be0d21"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "departure-header" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSvg = _resolveComponent("BaseSvg")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("h2", null, [
        _createVNode(_component_BaseSvg, {
          icon: _ctx.icon,
          class: _normalizeClass({'icon--return': _ctx.direction === _ctx.DirectionEnum.Return})
        }, null, 8, ["icon", "class"]),
        (_ctx.direction === _ctx.DirectionEnum.Outward)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t("departure.outward")), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t("departure.return")), 1))
      ]),
      _createElementVNode("h3", null, [
        _createElementVNode("span", null, _toDisplayString(_ctx.destinationNames[_ctx.fromDestination]), 1),
        _createVNode(_component_BaseSvg, { icon: 'arrow/arrow-long-right' }),
        _createElementVNode("span", null, _toDisplayString(_ctx.destinationNames[_ctx.toDestination]), 1)
      ])
    ])
  ]))
}